/**
 * D-17 — the one rule for "has the person typed the thing we asked for".
 *
 * A typed confirmation exists to make a destructive action deliberate: you
 * cannot reach it by muscle memory, because you have to read the row you are
 * about to destroy and reproduce its identifier. That is the whole purpose,
 * and it survives case-insensitive matching intact.
 *
 * Matching IS case-insensitive and trims surrounding whitespace, deliberately:
 * the value being typed here is an email address, which the rest of this
 * codebase normalises to lowercase before it ever reaches the database
 * (`normalizeEmail`). Demanding the exact casing of a displayed address would
 * reject a correct answer and teach people to copy-paste, which defeats the
 * deliberation the gate is for. Nothing is made safer by it.
 */
export function matchesTypeToConfirm(typed: string, expected: string): boolean {
  const a = typed.trim().toLocaleLowerCase();
  const b = expected.trim().toLocaleLowerCase();
  // An empty expectation would make the gate vacuous — a caller that passes
  // one has a bug, and an always-disabled button is the safe way to say so.
  if (b === '') return false;
  return a === b;
}
